export const fmtDate = (v) => {
  const s = String(v || "").slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}`;
  return v || "";
};

export const fmtDateTime = (v) => {
  const d = new Date(v);
  return isNaN(d.getTime()) ? (v || "") : d.toLocaleString("en-GB");
};
